// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#earth[data-v-3a09f18e]{position:relative;width:100%;height:58%;top:20%;background-color:#17293d;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
